// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isSaturday as fn } from "../isSaturday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isSaturdayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default isSaturdayWithOptions;
